import React, {Component} from 'react'

import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";



class LeumitRequestIsSentConnected extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }


    render() {

        let {t} =this.props
        return (
            <div>
                <div className={'asaya-info-selfOnboarding'}/>

                <div className={'patientsFormRow'}>
                    <label className={'payment_details'}>{t('patient_self_boarding.payment_done_note')}</label>
                </div>
            </div>


        )
    }
}


const LeumitRequestIsSent = compose(
    withTranslation(),
    connect(
        /*        mapStateToProps,
                mapDispatchToProps*/
    )
)(LeumitRequestIsSentConnected)

export default LeumitRequestIsSent;
